// JavaScript Document
//components/sign/category/Form.js
import React from 'react';
//import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
//import AppBar from '@material-ui/core/AppBar';

import Box from '@material-ui/core/Box';
//import {flexbox} from '@material-ui/system';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
//import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
//import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
//import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';

import Button from '@material-ui/core/Button';
import SaveIcon from '@material-ui/icons/Save';
import ImagePicker from '../forms/ImagePicker';
import DeleteButton from '../../core/DeleteButton';
//import TextArea from '@material-ui/core/TextareaAutosize';
//import Display from '../../display/Display';
//import Paper from '@material-ui/core/Paper';

const useStyles = makeStyles((theme) => ({
	advancedCard : {
		margin: theme.spacing(1),
		display: "flex",
		flexDirection:"column",
		alignItems:"stretch",
		justifyContent:"center"
	},
	advancedContent : {
		display: "flex",
		flexGrow: 1,
		alignItems: "center",
		justifyContent: "space-around",
	},
	detailsVerticalCenter: {
		display: "flex",
		alignItems:"center",
		justifyContent:"space-around",
		flexGrow: 1,
		flexDirection: "column",
		flexWrap: "wrap",
	},
	imgpicker: {
		width:150,
		height: 125
	},
	timingInput : {
		margin: theme.spacing(1),
		width: 90
	},
  maxDisplayGrid: {
	  minHeight: 300
  }
}));

export default function Category(props) {
  	const classes = useStyles();
	//inherited variables
  	const {handleSend, category, pics, onChange} = props;
	//locally stored/copied variables
	const [isNew, setIsNew] = React.useState(false);
	const [changed, setChanged] = React.useState(false);
	const [saveLabel, setSaveLabel] = React.useState('Save');

	const [details, setDetails] = React.useState({
		id: '',
		name: '',
		description: '',
		pic: '',
		type: 'sign_category',
	});
	//local state varialbes user will change
	//Local constant for maximum value
	
	//Refresh UI on props change
	React.useEffect(() => {
		if(!category.id){
			setIsNew(true);
		} else {
			setIsNew(false);
		}
		if(
			category.id 
			&& category.id !== details.id
		) {
			//console.log('config has changed');
			setDetails(category);
			
		}
	}, [category, details.id]);
	
	//handle change any value
	const handleChangeValue = (e) => {
		let name = e.target.name;
		let value = e.target.value
		let newDetails = Object.assign({}, details);
		
		newDetails[name] = value;
		setDetails(newDetails);
		setChanged(true);
	}
	
	//Handle save buttonclick
	const handleSave = (e) => {
		setSaveLabel('Saving');
		console.log("Save button clicked!");
		handleSend({
			vso: 'option',
			option: details,
			subaction: 'save'
		}, (data) => {
			console.log(data);
			setChanged(false);
			setSaveLabel('Save');
			//setConfig(data.config);
			setDetails(data.option);
			//update parent if onChange is supplied
			if(onChange){
				onChange(data.option, isNew);
			}
			setIsNew(false);
			
		});
	}
	
	//Final delete clicked
	const handleDelete = () => {
		setIsNew(true);
		handleSend({
			vso: 'option',
			option: details,
			subaction: 'delete'
		}, (data) => {
			setChanged(false);
			setIsNew(false);
			if(onChange){
				onChange(false);
			}
		})
	}
	

	
	//render card actions (save & Delete)
	const cardActions = () => {
		return (
			<ButtonGroup>
				{saveButton()}
				<DeleteButton onClick={handleDelete} visible={!isNew} />
			</ButtonGroup>
		)
	}
	

	//Handle update parent if onChange is provided
	/*
	const handleUpdateParent = (newTiming, newDim, newAlternate) => {
		if(onChange){
			console.log('Updating parent');
			onChange([newTiming.wigOn, newTiming.wigOff, newTiming.wagOn, newTiming.wagOff], newDim, newAlternate);
		}
	}
	*/
	const saveButton = () => {
		if(changed){
			return (
				<Button 
					variant="contained" 
					color="primary" 
					onClick={handleSave} 
					endIcon={<SaveIcon />}
					disabled={saveLabel==='Saving' ? true : false}
				>
					{saveLabel}
				</Button>
			);
		}
		return '';
	}
	
  	//standard size: 
	//1 panel = 6 x 9 x 2 rows = 30 x 18

  	return (
    	<Card className={classes.advancedCard}>
			<CardHeader title={(isNew ? 'New Category' : '')+details.name} action={cardActions()}/>
	  		<CardContent className={classes.advancedContent}>
				<Box className={classes.detailsVerticalCenter} p={3}>
					<TextField
						id="cat_name"
						name="name"
						label="Name"
						required
						value={details.name}
						type="text"
						inputProps = {{
									  maxlength:"25"
									 }}
						onChange={handleChangeValue}
						fullWidth
					/>
					<TextField
						id="cat_description"
						name="description"
						label="Description"
						multiline
						maxRows={4}
						value={details.description}
						onChange={handleChangeValue}
						fullWidth
					/>
				</Box>
				<ImagePicker
					id="cat_pic"
					label="Image"
					name="pic"
					value={details.pic}
					items={pics}
					onChange={handleChangeValue}
				/>
	  		</CardContent>
	  	</Card>
  );
}
